export enum DateInputMethodKinds {
  /** 入力不可 */
  None = 0,
  /** カレンダー */
  Calendar = 1,
  /** 西暦 yyyyMMdd */
  Ad = 2,
  /**
   * 和暦 コード＋yyMMdd
   * ※V1のソースを見る限りでは以下のコードをyymmddの頭に付与してどの和暦なのかを区別している？
   * 明治: 1
   * 大正: 2
   * 昭和: 3
   * 平成: 4
   */
  Jp = 3,
  /** 平成 yyMMdd */
  JpHeisei = 4,
  /** フリー入力 */
  FreeInput = 5,
  /** 計算入力 */
  Calculate = 6,
  /** HIS情報データ選択 */
  HisInfoSelect = 7,
  /** ユーザ定義データ選択 */
  UserDefinitionSelect = 8,
}
